<template>
    <div class="container">
        <div class="page_banner">
            <div class="page_title content">
                关于我们
            </div>
        </div>

        <div class="inner">
            <!-- 企业介绍 -->
            <enterprise-introduction class="intro"></enterprise-introduction>

            <!-- 荣誉资质 -->
            <honor v-if="!!webInfo.about.ryzz && webInfo.about.ryzz.length > 0"></honor>

            <!-- 参编书籍 -->
            <!-- <books></books> -->

            <!-- 公司文化 -->
            <corporate-culture></corporate-culture>

            <!-- 企业风采 -->
            <corporate-style v-if="!!webInfo.about.qyfc && webInfo.about.qyfc.length > 0"></corporate-style>

            <!-- 联系我们 -->
            <contact-us></contact-us>

            <!-- 相关下载 -->
            <downloads v-if="!!webInfo.about.xgxz && webInfo.about.qyfc.xgxz > 0"></downloads>
        </div>

    </div>

</template>

<script>
import {buildTdk} from '@config/tdk';
import EnterpriseIntroduction from './component/enterprise-introduction';
import CorporateCulture from './component/corporate-culture';
import CorporateStyle from './component/corporate-style';
import Honor from './component/honor';
import Books from './component/books';
import ContactUs from './component/contact-us';
import Downloads from './component/downloads.vue';

export default {
    head() {
        var tdk = (buildTdk('about'));
        tdk.title = tdk.title + '·' + tdk.webName;
        return tdk
    },
    components: {
        EnterpriseIntroduction,
        Honor,
        Books,
        CorporateCulture,
        CorporateStyle,
        ContactUs,
        Downloads,
    },
    data() {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>
<style lang='scss' scoped>
.container {
    background: #fff;
    padding-bottom: 37px;
    .page_banner {
        width: 100%;
        height: 365px;
        background: url(/images/about/bg.png) no-repeat;
        background-size: 100% 100%;
        padding-top: 59px;
        padding-left: 19px;

        .page_title {
            font-size: 30px;
            color: #131415;
            font-weight: bold;
        }
    }

    .inner {
        margin-top: -220px;
    }
}
</style>
